export default __webpack_public_path__ + "static/media/home-top4.7cc42d69.jpg";